// NotificationContext.tsx
import React, { createContext, ReactNode, useContext, useState } from 'react';
import { ToastMessage } from '../../components/toast-message/ToastMessage';
import { NotificationType } from '../../model/Types';

interface NotificationContextType {
    showInfo: (message: string) => void;
    showSuccess: (message: string) => void;
    showError: (message: string) => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider = ({ children }: { children: ReactNode }) => {
    const [toastOpen, setToastOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [type, setType] = useState<NotificationType>(NotificationType.SUCCESS);

    const showInfoMessage = (msg: string) => {
        setMessage(msg);
        setType(NotificationType.INFO);
        setToastOpen(true);
    };

    const showErrorMessage = (msg: string) => {
        setMessage(msg);
        setType(NotificationType.ERROR);
        setToastOpen(true);
    };

    const showSuccessMessage = (msg: string) => {
        setMessage(msg);
        setType(NotificationType.SUCCESS);
        setToastOpen(true);
    };

    const handleClose = () => setToastOpen(false);

    return (
        <NotificationContext.Provider
            value={{
                showInfo: showInfoMessage,
                showError: showErrorMessage,
                showSuccess: showSuccessMessage,
            }}
        >
            {children}
            <ToastMessage
                toastOpen={toastOpen}
                message={message}
                onToastClose={handleClose}
                type={type}
            />
        </NotificationContext.Provider>
    );
};

export const useNotification = () => {
    const context = useContext(NotificationContext);
    if (!context) throw new Error('useToast must be used within ToastProvider');
    return context;
};
